import Rellax from 'rellax';

class FiftyFiftyParallax extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new Rellax(this.querySelector('.rellax'), {
      center: true
    });
  }
}

customElements.get('fifty-fifty-parallax') ||
  customElements.define('fifty-fifty-parallax', FiftyFiftyParallax);
